import { cx } from 'cva';

interface CheckmarkProps {
  color: 'blue' | 'gray' | 'purple';
}

export function Checkmark({ color }: CheckmarkProps) {
  return (
    <svg
      className={cx('inline-flex', {
        'stroke-[#00AEE3]': color === 'blue',
        'stroke-newGray-400': color === 'gray',
        'stroke-newPurple-500': color === 'purple'
      })}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 9L7 12L12 4"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
